import { render, staticRenderFns } from "./Customer_Details.vue?vue&type=template&id=77696f44&scoped=true"
import script from "./Customer_Details.vue?vue&type=script&lang=js"
export * from "./Customer_Details.vue?vue&type=script&lang=js"
import style0 from "./Customer_Details.vue?vue&type=style&index=0&id=77696f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77696f44",
  null
  
)

export default component.exports